<template>
  <div id="reset_password_first_access">
    <div
      v-if="!showFeedbackModal"
      class="block__reset_password"
    >
      <CardLayoutLogo />
      <div class="change__password_subtitle">
        Por segurança, você precisa definir uma nova senha antes de continuar. Esta ação foi
        solicitada pelo administrador do sistema.
      </div>
      <div class="change__password_title">Altere sua senha</div>
      <div class="rule__options_block">
        <span :class="rule_1 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_1" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          Mínimo 6 caracteres
        </span>
        <span :class="rule_2 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_2" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          Deve conter ao menos 1 número
        </span>
        <span :class="rule_3 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_3" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          Deve conter ao menos 1 caractere especial
        </span>
        <span :class="rule_4 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_4" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          As senhas devem ser iguais
        </span>
      </div>
      <div class="block__passwords_inputs">
        <div
          v-if="showErrorMessage"
          class="block__error_messsage"
        >
          Todos os requisitos devem ser cumpridos
        </div>
        <InputText
          input-i-d="password-input"
          :vmodel.sync="password"
          field-label="Nova Senha"
          field-placeholder="Digite aqui sua nova senha"
          :state="states.password"
          :invalid-feedback="''"
          input="password"
          @change="validatePassword"
        />
        <InputText
          input-i-d="confirm-password-input"
          :vmodel.sync="password_confirm"
          field-label="Repita a Nova Senha"
          field-placeholder="Redigite a nova senha"
          :state="states.password_confirm"
          :invalid-feedback="''"
          input="password"
          @change="validateEqualPassword"
        />
      </div>

      <div class="block__footer_buttons">
        <ButtonFullWidth @click="savePassword">
          <div slot="text">Salvar Senha</div>
        </ButtonFullWidth>
        <ButtonFullWidth
          button-color="white"
          @click="_logout"
        >
          <div slot="text">Cancelar</div>
        </ButtonFullWidth>
      </div>
    </div>
    <modal-confirm
      v-else
      title="Senha alterada"
      subtitle="Agora você pode acessar sua conta com a nova senha criada"
      :button-text="getButtonText()"
      @click="redirectToCorrectPage"
    />
  </div>
</template>

<script>
  import CardLayoutLogo from '@/views/authentication/components/card-layout/components/indsiders-logo';
  import DotIcon from '@/assets/icons/rule-options-icon.svg';
  import CheckCircleIcon from '@/assets/icons/check-circle-icon.svg';
  import InputText from '@/components/input-text/index.vue';
  import ButtonFullWidth from '@/components/buttons/button-full-width';
  import ModalConfirm from '../modalConfirm.vue';

  export default {
    components: {
      CardLayoutLogo,
      DotIcon,
      CheckCircleIcon,
      InputText,
      ButtonFullWidth,
      ModalConfirm
    },
    data() {
      return {
        password: '',
        password_confirm: '',
        rule_1: false,
        rule_2: false,
        rule_3: false,
        rule_4: false,
        showFeedbackModal: false,
        showErrorMessage: false,
        states: {
          password: null,
          password_confirm: null
        }
      };
    },
    mounted() {
      const userInfo = this.$cookies.get('userInfo');
      this.showFeedbackModal = !userInfo.passwordChangeRequired;
    },
    methods: {
      getButtonText() {
        const userInfo = this.$cookies.get('userInfo');
        return userInfo.pinChangeRequired ? 'Alterar PIN' : 'Ir para MyInd';
      },
      redirectToCorrectPage() {
        const userInfo = this.$cookies.get('userInfo');
        this.$router
          .push({
            name: userInfo.pinChangeRequired ? 'first-access-reset-pin' : 'home'
          })
          .catch(() => {});
      },
      validatePassword() {
        this.rule_1 = this.password.length >= 6;
        this.rule_2 = this.checkIfHasNumberInString(this.password);
        this.rule_3 = this.checkIfHasSpecialCharacterInString(this.password);
        this.password_confirm !== '' && (this.rule_4 = this.password === this.password_confirm);
      },
      validateEqualPassword() {
        this.password !== '' && (this.rule_4 = this.password === this.password_confirm);
      },
      checkIfHasNumberInString(string) {
        const re = /\d/;
        return re.test(string);
      },
      checkIfHasSpecialCharacterInString(string) {
        const re = /[!@#$%^&*(),.?":{}|<>]/;
        return re.test(string);
      },
      async savePassword() {
        this.showErrorMessage = false;
        const isValid = this.rule_1 && this.rule_2 && this.rule_3 && this.rule_4;
        this.states.password = isValid ? null : false;
        this.states.password_confirm = isValid ? null : false;

        if (!isValid) {
          this.showErrorMessage = true;
          return;
        }

        const payload = {
          password: this.password
        };
        const domain = window.location.href.includes('indsiders.com');

        await this.$http2.put(`/api/user/change-password`, payload).then(() => {
          const userInfo = this.$cookies.get('userInfo');
          this.$cookies.set(
            'userInfo',
            {
              ...userInfo,
              passwordChangeRequired: false
            },
            '7D',
            null,
            domain ? 'indsiders.com' : null
          );
          this.showFeedbackModal = true;
        });
      }
    }
  };
</script>

<style lang="scss">
  #reset_password_first_access {
    min-height: 100dvh;
    width: 100%;
    padding: 37px 18px;
    background-image: url('../../../assets/images/cubos.png');
    background-color: #362f2b;
    background-size: 175px;

    display: flex;
    align-items: center;
    justify-content: center;

    .block__reset_password {
      display: flex;
      background-color: #fff;
      max-width: 527px;
      padding: 24px;
      flex-direction: column;
      align-items: flex-start;
      border-radius: 6px;
      border: 1px solid #cfc4be;
      box-shadow: 0px 12px 17px 0px rgba(0, 0, 0, 0.14), 0px 5px 22px 0px rgba(0, 0, 0, 0.12),
        0px 7px 8px 0px rgba(0, 0, 0, 0.2);

      .change__password_subtitle {
        color: #998f8a;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        padding-block: 24px;
        text-align: start;
      }

      .change__password_title {
        color: #4c4541;
        font-size: 28px;
        font-weight: 600;
        line-height: 38px;
        padding-bottom: 8px;
      }

      .rule__options_block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        padding-bottom: 16px;
        width: 100%;
        border-bottom: 1px solid #eee;

        span {
          display: flex;
          align-items: center;
          text-align: start;
          gap: 8px;
          color: #998f8a;
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;

          .check__icon {
            width: 12px;
            height: 12px;
            path {
              fill: #4caf50;
            }
          }

          &.is-valid {
            color: #4caf50;
          }
        }
      }

      .block__passwords_inputs {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-block: 16px;
        width: 100%;

        .block__error_messsage {
          display: flex;
          padding: 16px;
          align-items: center;
          gap: 16px;
          border-radius: 6px;
          border: 1px solid #b71c1c;
          background: #ffebee;
          color: #b71c1c;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }

      .block__footer_buttons {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-top: 16px;
        width: 100%;
      }

      @media (max-width: 480px) {
        padding-inline: 15px;
        .change__password_subtitle {
          font-size: 12px;
          line-height: 16px;
          padding-bottom: 16px;
        }

        .change__password_title {
          font-size: 22px;
          line-height: 30px;
        }

        .rule__options_block {
          gap: 0;
          span {
            font-size: 12px;
            line-height: 16px;
          }
        }

        .block__passwords_inputs {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding-block: 16px;
          width: 100%;

          .block__error_messsage {
            font-size: 12px;
            line-height: 16px;
          }
        }

        .block__footer_buttons {
          padding-top: 8px;
        }
      }
    }
  }
</style>
